import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';  // Global styles (reset, base)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
